import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface CalculatorTransferData {
  source: 'mortgage-loan' | 'tdsr-msr' | 'sales-proceed' | 'investment-timeline';
    data: {
    // Mortgage Loan data
    maxMonthlyMortgage?: number;
    stressTestRate?: number;
    interestRate?: number;
    loanTenure?: number;
    loanToValue?: number;
    maxLoanAmount?: number;
    maxTotalPropertyPrice?: number;
    
    // TDSR/MSR data
    monthlyIncome?: number;
    monthlyMortgage?: number;
    otherDebts?: number;
    propertyValue?: number;
    
    // Other calculator data can be added here
    // Sales Proceed data
    cpfRefundFromSales?: number;
    cashProceedsFromSale?: number;
  };
}

interface CalculatorDataContextType {
  transferData: CalculatorTransferData | null;
  setTransferData: (data: CalculatorTransferData | null) => void;
}

const CalculatorDataContext = createContext<CalculatorDataContextType | undefined>(undefined);

export const CalculatorDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [transferData, setTransferData] = useState<CalculatorTransferData | null>(null);

  return (
    <CalculatorDataContext.Provider value={{ transferData, setTransferData }}>
      {children}
    </CalculatorDataContext.Provider>
  );
};

export const useCalculatorData = () => {
  const context = useContext(CalculatorDataContext);
  if (!context) {
    throw new Error('useCalculatorData must be used within CalculatorDataProvider');
  }
  return context;
};




